module.exports = "/images/palmera-01.png?7cbd7ba57c78f0d572caccf837f55866";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/palmera-01.png
// module id = PB40
// module chunks = 0